const DefaultLayout = ({ children }) => <div>{children}</div>;

export default DefaultLayout;
